import services from 'utils/mockAdapter';
// user list
const VariablesList = [
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '1'
    },
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '0'
    },
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '0'
    },
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '0'
    },
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '1'
    },
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '1'
    },
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '0'
    },
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '0'
    },
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '0'
    },
    {
        id: '10011',
        name: 'MSC ',
        description: 'IOT Variable  Description of the bla blla bla ',
        displaytype: 'On/Off',
        iotfield: 'MSC',
        dbfield: 'MSC',
        isstatic: '0'
    }
];
// ==============================|| MOCK SERVICES ||============================== //
services.onGet('/api/manufacturers/variables/list').reply(200, { VariablesList });
